/* eslint-disable max-lines */

import plural from 'plurals-cldr'
import {LangType} from './lang'
import {LangUtil, PluralNoun} from './lang-util'
import {billRu} from './parts/bill'
import {boardRu} from './parts/board'
import {boardAppearanceRu} from './parts/board-appearance'
import {calendarRu} from './parts/calendar'
import {chatRu} from './parts/chat'
import {colorPickerRu} from './parts/color-picker'
import {columnOrderRu} from './parts/column-order'
import {commonRu} from './parts/common'
import {companiesRu} from './parts/companies'
import {companyDashboardRu} from './parts/company-dashboard'
import {componentRu} from './parts/component'
import {crmRu} from './parts/crm'
import {dependencyRu} from './parts/dependency'
import {emojiReactionsRu} from './parts/emoji-reactions'
import {extensionsRu} from './parts/extensions'
import {feedbackRu} from './parts/feedback'
import {fileViewerRu} from './parts/file-viewer'
import {globalSearchRu} from './parts/global-search'
import {googleCalendarRu} from './parts/google-calendar'
import {groupChatEditorRu} from './parts/group-chat'
import {helpRu} from './parts/help'
import {importFromFileRu} from './parts/import-from-file'
import {importFromTrelloRu} from './parts/importFromTrello'
import {invitePopupRu} from './parts/invite-popup'
import {menuRu} from './parts/menu'
import {messageForwardingRu} from './parts/message-forwarding'
import {mirroredTasksRu} from './parts/mirrored-tasks'
import {movementTemplatesRu} from './parts/movement-templates'
import {multiActionsWithTasksRu} from './parts/multi-actions-with-tasks'
import {myStickersRu} from './parts/my-stickers'
import {myTasksRu} from './parts/my-tasks'
import {noLicenseRu} from './parts/no-license'
import {partnerRu} from './parts/partner'
import {permissionRu} from './parts/permission'
import {profilePageRu} from './parts/profile-page'
import {projRu} from './parts/proj'
import {regRu} from './parts/regRu'
import {repeatRu} from './parts/repeat'
import {reportRu} from './parts/report'
import {screencastRu} from './parts/screencast'
import {serverRu} from './parts/server'
import {shareRu} from './parts/share'
import {statsReportsTableRu} from './parts/stats-reports-table'
import {statsTimelineRu} from './parts/stats-timeline'
import {stickerItemRu} from './parts/sticker-item'
import {stickerNamesRu} from './parts/sticker-names'
import {stickerPanelRu} from './parts/sticker-panel'
import {subtaskRu} from './parts/subtask'
import {taskPageRu} from './parts/task-page'
import {taskTemplatesRu} from './parts/task-templates'
import {timelineRu} from './parts/timeline'
import {userEventRu} from './parts/user-events'
import {usersRu} from './parts/users'
import {usersTableRu} from './parts/usersTable'
import {votingRu} from './parts/voting'
import {workflowRu} from './parts/workflow'

export const langRu: LangType = {
  lang: 'ru',
  imgCode: 'ru',
  langName: 'Русский',

  component: componentRu,
  subtask: subtaskRu,
  report: reportRu,
  server: serverRu,
  repeat: repeatRu,
  stickerNames: stickerNamesRu,
  common: commonRu,
  companies: companiesRu,
  timeline: timelineRu,
  dependency: dependencyRu,
  permission: permissionRu,
  reg: regRu,
  menu: menuRu,
  googleCalendar: googleCalendarRu,
  stickerPanel: stickerPanelRu,
  profilePage: profilePageRu,
  chat: chatRu,
  feedback: feedbackRu,
  taskPage: taskPageRu,
  myTasks: myTasksRu,
  users: usersRu,
  proj: projRu,
  help: helpRu,
  partner: partnerRu,
  bill: billRu,
  userEvents: userEventRu,
  extensions: extensionsRu,
  share: shareRu,
  stickerItem: stickerItemRu,
  statsTimeline: statsTimelineRu,
  statsReportsTable: statsReportsTableRu,
  colorPicker: colorPickerRu,
  calendar: calendarRu,
  importFromTrello: importFromTrelloRu,
  importFromFile: importFromFileRu,
  emojiReactions: emojiReactionsRu,
  companyDashboard: companyDashboardRu,
  workflow: workflowRu,
  myStickers: myStickersRu,
  groupChatEditor: groupChatEditorRu,
  messageForwarding: messageForwardingRu,
  fileViewer: fileViewerRu,
  multiActionsWithTasks: multiActionsWithTasksRu,
  board: boardRu,
  mirroredTasks: mirroredTasksRu,
  columnOrder: columnOrderRu,
  usersTable: usersTableRu,
  screencast: screencastRu,
  movementTemplates: movementTemplatesRu,
  taskTemplates: taskTemplatesRu,
  invitePopup: invitePopupRu,
  boardAppearance: boardAppearanceRu,
  noLicense: noLicenseRu,
  globalSearch: globalSearchRu,
  voting: votingRu,
  crm: crmRu,

  monthsFirstForm: [
    'Янв',
    'Фев',
    'Март',
    'Апр',
    'Май',
    'Июнь',
    'Июль',
    'Авг',
    'Сент',
    'Окт',
    'Ноя',
    'Дек'
  ],

  months: [
    'Янв',
    'Фев',
    'Мар',
    'Апр',
    'Мая',
    'Июня',
    'Июля',
    'Авг',
    'Сент',
    'Окт',
    'Ноя',
    'Дек'
  ],

  monthsFull: [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря'
  ],

  mainTitle: 'YouGile',
  whatsNew: 'Что нового:',
  coworkers: 'Сотрудники компании',
  admins: 'Администраторы',
  usersStr: 'Пользователи',
  signup: 'Зарегистрироваться',

  of: 'из',
  from: 'от',
  to: 'до',
  pcs: 'шт.',

  loadBg: 'Загрузить новый фон',
  account: 'Аккаунт',
  editAccount: 'Редактировать профиль',
  logout: 'Выход из аккаунта',
  phone: 'Телефон',
  phonePl: 'Введите ваш номер телефона',
  name: 'Имя',
  namePl: 'Введите ваше имя',
  namePlaceholder: 'Ваше имя',
  nameEmpty: 'Имя не задано',
  phoneEmpty: 'Укажите ваш контактный телефон',
  phoneIncorrect: 'Проверьте правильность указанного телефона',
  companyEmpty: 'Укажите название вашей компании',
  sHSuccess: 'Готово, мы свяжемся с вами в ближайшее время',
  nameShort: 'Слишком короткое имя',
  email: 'E-mail',
  emailPl: 'Введите ваш e-mail',
  yourEmail: 'Ваш e-mail:',
  emailPlaceholder: 'E-mail…',
  emailIncorrect: 'Неверный e-mail',
  emailIncorrect2: 'Проверьте правильность e-mail',
  emailExists: 'Пользователь с таким e-mail уже зарегистрирован.',
  incorrectEmailPass: 'Неверный e-mail или пароль',
  forgotAcc: 'Забыли пароль?',
  resetPass: 'Восстановите пароль:',
  resetPass2: 'Восстановить',
  resetPassSent: 'Вам на почту было выслано письмо с ссылкой на сброс пароля',
  go: 'Вперёд!',
  password: 'Пароль',
  passwordPl: 'Придумайте пароль',
  passwordShort: 'Пароль слишком короткий',
  noPassword: 'Пароль не указан',
  passwordPlaceholder: 'Пароль',
  startTrial: 'Попробовать сейчас',
  signIn: 'Войти!',
  signIn2: 'войти',
  signIn3: 'Войти',
  serverError: 'Ошибка от сервера',
  optional: '(не обязательно)',
  required: '(обязательно)',
  startUsing: 'Готово!',
  addAsNewLabel: (value: string) => `Добавить «${value}» как новый`,
  registerLastStep: 'Последний шаг – заполните свой профиль:',
  haveAcc: 'Уже зарегистрированы?',
  unexpectedErr: 'Неизвестная ошибка',
  resetPassEmailInfo:
    'Вам было выслано письмо для сброса пароля, пройдите ' +
    'по ссылке в письме, чтобы установить новый пароль',
  registration: 'Регистрация',
  doRegister: 'Вперёд!',
  uploadPhoto: 'Загрузить фото',
  uploadPhoto2: 'Загрузить фото…',
  uploadAnotherPhoto: 'Загрузить другое фото…',
  save: 'Сохранить',
  ok: 'Ok',
  create: 'Создать',
  createTask: 'Создать задачу',
  cancel: 'Отмена',
  apply: 'Применить',
  close: 'Закрыть',
  finish: 'Завершить',
  yes: 'Да',
  no: 'Нет',
  add: 'Добавить',
  and: 'и',
  unpin: 'открепить',
  historyChanges: 'История изменений',
  stopStopwatch: 'Остановить секундомер',
  stopTimer: 'Остановить таймер',
  startStopwatch: 'Запустить секундомер',
  startTimer: 'Запустить таймер',
  startedBy: 'Запущено',
  stoppedBy: 'Остановлено',
  runTime: 'Время работы:',
  stoppedTime: 'Время остановки:',
  set: 'установлен',
  weeks: 'Недель',
  days: 'Дней',
  hours: 'Часов',
  minutes: 'Минут',
  w: 'нед',
  d: 'д',
  h: 'ч',
  m: 'мин',
  s: 'сек',
  mShort: 'м',
  timeWeek: 'Неделя',
  time2Week: 'Две недели',
  timeMonth: 'Месяц',
  timeCustom: 'Свои даты',
  change: 'Изменить',
  start: 'Запустить',
  totalStopsTime: 'Общее время остановки:',
  goBack: 'вернуться…',
  back: 'Назад',
  timeInColumnsTitle: (boardTitle: string, projectTitle: string) =>
    `Доска “${boardTitle}” проекта “${projectTitle}”`,
  averageTimeInColumns: 'Среднее время в колонках',
  averageTimeInColumnsDescription:
    'Мы подсчитали, сколько времени задачи провели в каждой колонке,' +
    'усреднили это и показали на графике. \n \n' +
    'Если колонка красная и высокая - вам стоит обратить на нее внимание,' +
    'это то место, где задачи проводят больше всего времени',
  hide: 'Скрыть',
  show: 'Показать',
  showAll: 'Показать все',
  all: 'Все',
  allColumns: 'Все колонки',
  allProjects: 'Все проекты',
  chooseColor: 'Выберите цвет:',
  stickers: 'стикеры',
  stickers2: 'Стикеры',
  user: 'Пользователь',
  openTask: 'К задаче',
  deadline: 'Дедлайн',
  timer: 'Таймер',
  timerDescription:
    'Установите время, через которое задача должна быть завершена.',
  stopwatch: 'Секундомер',
  dragStickerToTask: 'Перенесите этот стикер с панели стикеров на задачу.',
  stopwatchDescription:
    'Секундомер будет показывать сколько времени задача находится в открытом состоянии.',
  timetracking: 'Таймтрекинг',
  nMessages: 'сообщений',
  projects: 'Проекты',
  projectsMenuTitle: 'Проекты и права доступа',
  project: 'Проект',
  accountAndSettings: 'Аккаунт / Настройки',
  companyProjects: 'Проекты компании',
  addProject: 'Добавить проект',
  addProjectWithTasks: 'Добавить проект с задачами',
  addBoard: 'Добавить доску',
  addColumn: 'Добавить колонку',
  addTask: 'Добавить задачу',
  extensionsInColumnLabel: 'Расширения в колонке:',
  confirmDeleteCompany: 'Вы действительно хотите удалить эту компанию?',
  confirmDeleteCompany2:
    'Вы потеряете все данные по этой компании ' +
    '(файлы, чаты, задачи). Продолжить?',
  confirmDeleteCompany3: 'Удалиться из компании?',
  confirmDeleteCompany3Hint:
    'Вы будете удалены из компании и не сможете вернуться в неё без повторного приглашения от администратора',
  disallowDeleteOnlyCompany:
    'Это ваша единственная компания, ' +
    'чтобы удалить её, создайте новую компанию',
  disallowRenameCompanyNotAdmin: 'Вы не администратор в этой компании.',
  notAdmin: 'Вы не администратор в текущей компании.',
  companyDeleted: 'Компания успешно удалена',
  confirmDeleteProject: 'Удалить проект?',
  confirmDeleteProjectHint:
    'При удалении проекта будут удалены все задачи в нём',
  projectPlaceholder: 'Введите название проекта…',
  project404: 'Проект не найден',
  allUsers: 'Все пользователи',
  invite: 'Пригласить',
  inviteAnother: 'Пригласить другого человека',
  inviteAgain: 'Пригласить еще одного человека',
  userInviteOk: 'Пользователь успешно приглашён',
  usersInviteOk: (n: number) => `Пользователи успешно приглашены, к-во: ${n}`,
  failedToSendInvitation:
    'Не удалось отправить приглашение, ' +
    'проверьте правильность указанного e-mail',
  userInviteAlreadyInvited: 'Пользователь уже был приглашен',
  inviteByEmailAlt: 'Выслать приглашение на почту',
  newContact: 'Новый контакт',
  emailToInvite: 'E-mail человека, которого хотите пригласить:',
  showMore: 'Показать все »',
  showMore2: 'Показать больше',
  showMore31: 'Показать',
  showMore32: 'больше',
  showMoreTasks: (count: number) =>
    `Показать еще ${count} ${langRu.taskNounAcc[plural('ru', count)]}`,
  showLess: '« Показать меньше',
  chats: 'Диалоги по задачам',
  chats2: 'Чаты',
  saveChanges: 'Сохранить изменения',
  description: 'Описание',
  addDescription: 'Добавить описание',
  editDescription: 'Редактировать описание',
  editTaskNamePlaceholder: 'Название задачи',
  saveDescription: 'Сохранить описание',
  descriptionPlaceholder: 'Текст описания задачи…',
  labelPlaceholder: 'Название метки…',
  typing: 'печатает…',
  moreTyping: (count: number) =>
    `и ещё ${count} ${langRu.personNoun[plural('ru', count)]} печатают…`,
  newMsg: 'Новое сообщение',
  writeNewMessage: 'Напишите сообщение в чат',
  justFeedback: 'Обратная связь',
  dropFileToChat: 'Отпустите файл, чтобы добавить его в чат.',
  addPeopleToProject: 'Добавить сотрудника в проект',
  orInviteByEmail: 'Или пригласите сотрудника в проект по e-mail:',
  warnSelfDeleteFromProject:
    'Если вы удалите себя из проекта, то не сможете ' +
    'самостоятельно добавить себя обратно. Продолжить?',
  warnLastUserInProject:
    'Невозможно удалить последнего сотрудника из ' +
    'проекта. Удалите сам проект вместо этого.',
  chooseStickerIcon: 'Иконка стикера:',
  confirmStickerStateDelete: 'Удалить состояние стикера?',
  confirmStickerDelete: 'Удалить этот стикер?',
  stickerStatePlaceholder: 'Введите название…',
  addState: 'Добавить состояние',
  userOnline: 'Пользователь онлайн.',
  userOffline: 'Пользователь офлайн.',
  userOfflineSeenAt: 'Пользователь офлайн, последний раз был онлайн ',
  userDnd:
    'Пользователь в состоянии “Не беспокоить” и не будет получать ' +
    'уведомления до ',
  version: 'Версия',
  restart: 'Перезапуск',
  newUpdateHint: 'Вышло обновление, версия ',
  newUpdateAlreadyHint: 'Система обновлена до версии ',
  updateOk: 'Закрыть',
  reload: 'Обновиться',

  notifyPeople: 'Получат уведомление:',
  nobodyNotified: 'Никто не получит уведомление!',
  nobodyNotifiedExceptYou: 'Никто кроме вас не получит уведомление!',
  changePass: 'Сменить пароль',
  changeEmail: 'Сменить e-mail',
  typeNewPass: '* * *',
  typeOldPass: '* * *',
  newPass: 'Новый пароль',
  newPassShort: 'Новый пароль слишком короткий',
  newPassEmpty: 'Новый пароль не задан',
  oldPass: 'Старый пароль',
  incorrectOldPass: 'Старый пароль неверный',
  passChangeOk: 'Пароль изменён успешно',
  savePass: 'Сохранить пароль',
  yourLang: 'Язык интерфейса:',
  displayedName: 'Отображаемое имя…',
  uploadNewPhoto: ' Изменить фото…',
  imageTypeUnsupported: 'Неподдерживаемый тип изображения',
  freeTariffWarning:
    'Платная лицензия вашей компании закончилась. Последние действия в системе не будут сохранены. Обратитесь к администратору.',
  freeTariffWarningForAdmin:
    'Платная лицензия вашей компании закончилась. Последние действия в системе не будут сохранены. Оплатите лицензию или удалите лишних пользователей.',
  turnOffNotifications: 'Отключение уведомлений',
  min30: 'На 30 минут',
  hour1: 'На 1 час',
  hour2: 'На 2 часа',
  hour4: 'На 4 часа',
  hour8: 'На 8 часов',
  hour24: 'На 24 часа',
  notificationsSnoozed: 'Уведомления отключены до',
  noNotifications: 'Нет новых уведомлений',
  turnOnNotifications: 'Включить уведомления',
  myConversations: 'Мои чаты',
  othersConversations: 'Другие чаты',
  markAsSeen: 'Отметить как прочитанные',
  confirmBoardDelete: 'Удалить доску?',
  moreNewTasks: 'Ещё новых задач:',
  moreTasks: 'Ещё задач:',
  moreUsers: 'Ещё пользователей:',
  archivedTasks: 'Архив задач',
  taskPlaceholder: 'Введите название задачи…',
  confirmDeleteTask: 'Удалить эту задачу?',
  msgHint: 'Чат задачи, нажмите, чтобы открыть диалог',
  deleteTask: 'Удалить задачу',
  editTask: 'Редактировать название задачи',
  createColumn: 'Создать колонку',
  columnPlaceholder: 'Введите имя колонки…',
  addMirror: 'Создать зеркало',
  mirror: 'Зеркало',
  chooseColumns: 'Выберите колонки:',
  mirrorColumn: 'Зеркало',
  reportColumn: 'Сводка',
  mirrorColumnDefaultTitle: 'Зеркало',
  pinStickerToColumn:
    'Прикрепить стикер ко всем отображённым ' + 'задачам в этой колонке?',
  pinStickerToColumnUnavailable:
    'Этот стикер нельзя прикрепить ко всем задачам в колонке, можно прикрепить только к отдельным задачам',
  clickTaskConnect:
    'Нажмите на задачу, чтобы создать быструю ссылку на неё в задаче',
  clickToConnect: 'Нажмите, чтобы связать эту задачу с другой задачей',
  confirmDisconnect: 'Удалить ссылку на задачу?',
  clickDisconnect: 'Нажмите, чтобы убрать связь задач',
  created: 'Создано',
  byUser: 'пользователем ',
  atTime: ' ',
  openDirectChat: 'Написать личное сообщение',
  directChatVisibleOnly: 'Этот чат виден только вам и',
  msgSeenEverybody:
    'Все подписанные на чат пользователи прочитали ' + 'это сообщение',
  msgSeenNobody: 'Никто не прочитал это сообщение',
  msgSeenSomebody: 'Прочитали',
  connectedTasks: 'Ссылки на другие задачи',
  alreadyAddedStickerBoard: 'Уже добавлен в доску',
  removeFromBoard: 'Убрать из доски',
  removeFromTask: 'Удалить с задачи',
  chooseStickerType: 'Выберите тип стикера:',
  stickerText: 'Стикер с текстовым значением',
  stickerNumeric: 'Стикер с числовым значением',
  stickerString: 'Стикер с текстовыми состояниями',
  stickerStringExp: '– подходит для добавления информации о категории задачи.',
  stickerStringEg: 'Пример: приоритет, продукт, подсистема и т.д.',
  stickerSprint: 'Стикер спринт',
  stickerSprintExp:
    '– подходит для указания принадлежности задачи к ' +
    'диапазону дат в итеративном процессе',
  stickerSprintEg: 'Пример: Scrum спринты, недельные планы, и т.д.',
  stopwatchExp: `– позволяет добавлять к задачам секундомер, который можно
                 запускать и останавливать, что позволяет, например, следить
                 за потраченным на задачу временем.`,
  timerExp: `– позволяет устанавливать на задачи таймер с обратным отсчётом,
             который может показывать сколько времени осталось до
             запланированного завершения задачи.`,
  deadlineExp: `– позволяет добавлять дедлайн к задачам в доске.`,
  userExp: `– позволяет указывать в задаче исполнителя из числа добавленных
            в проект.`,
  timetrackingExp: `– добавляет возможность указывать план и факт в задачах
    на доске`,
  orAddStickerFromOtherBoard: 'Или добавьте стикер из другой доски:',
  chooseSticker: 'выберите стикер',
  stopwatchHeader: 'Стикер «Секундомер»',
  timerHeader: 'Стикер «Таймер»',
  timetrackingHeader: 'Стикер «Timetracking»',
  deadlineHeader: 'Стикер «Дедлайн»',
  userHeader: 'Стикер «Исполнитель»',
  deleteSticker: 'Удалить стикер',
  deleteStickerHead: 'Удаление стикера',
  deleteStickerBoard: 'Убрать из этой доски',
  deleteStickerFull: 'Удалить полностью из системы',
  deleteGroupWarn: 'Удалить колонку?',
  deleteGroupWarnHint: 'При удалении колонки будут удалены все задачи в ней',
  deleteMirrorWarn: 'Удалить зеркальную колонку?',
  deleteMirrorWarnHint: 'При удалении зеркала сама колонка удалена не будет',
  weCreatedExampleStates: `Для примера создано несколько состояний, вы можете
                           использовать их или удалить и создать другие.`,
  stickerName: 'Название стикера:',
  stickerFilterName: 'Название',
  sticker: 'Стикер',
  none: 'Сбросить',
  boardSettingsMain: 'Основные',
  boardSettingsAppearance: 'Внешний вид',
  boardSettingsStickers: 'Стикеры',
  boardSettingsSharing: 'Доступ по ссылке',
  boardSettingsMoveTasks: 'Передача задач',
  boardSettingsTaskTemplate: 'Шаблоны задач',
  boardSettingsGantt: 'Вид Ганта',
  notEnoughPermissions: 'У вас недостаточно прав для доступа к данному разделу',
  unknownError: 'Неизвестная ошибка, попробуйте позже',
  stickerNameIcon: 'Название и иконка стикера:',
  stickerPlaceholder: 'Название стикера…',
  stickerStates: 'Состояния стикера:',
  stickerStates2: 'Состояния',
  stickerNoName: 'Укажите название стикера',
  editSticker: 'Редактирование стикера',
  addRemoveSticker: 'Добавить/удалить стикер',
  quickLinks: 'Быстрые ссылки',
  createStickerIn: 'Создание нового стикера в ',
  removeAdmin: 'Убрать из администраторов компании',
  addAdmin: 'Назначить администратором компании',
  inviteUser: 'Пригласить пользователя',
  addUserToProjects: 'Добавить пользователя в проекты',
  addUserToProjects2: 'Добавить приглашаемых в проекты',
  addInvitationText: 'Добавить текст приглашения',
  deleteCompany: 'Удалить компанию',
  deleteContact:
    'Вы действительно хотите удалить этого пользователя из ' +
    'списка контактов',
  latestActivity: 'Последняя активность',
  companiesList: 'Компании',
  company: 'Компания',
  renameCompany: 'Переименовать компанию',
  delCompany: 'Удалить компанию',
  configureCompany: 'Настроить компанию',
  configureCompany2: 'Конфигуратор системы',
  configureCompany3: 'Открыть конфигуратор текущей компании',
  companyPlaceholder: 'Название компании',
  addCompany: 'Добавить компанию',
  addContactAndProjects: 'Добавить в проекты',
  addContactHint:
    'Укажите e-mail человека, которого хотите добавить. ' +
    'После добавления вы сразу сможете общаться с ним через YouGile.',
  successAddedContact: 'Вы успешно добавили',
  successAddedContact2: 'в список контактов для личной переписки.',
  createCompany: 'Создать новую компанию',
  createCompanyHint: 'Введите название компании, например: “Apple Inc.”',
  directMsg: 'Личные сообщения',
  searchMsgPlaceholder: 'Поиск по сообщениям',
  msgHistory: 'История сообщений',
  contacts: 'Контакты',
  searchResults: 'Результаты поиска',
  searchResultsLimited: (count: string | number) =>
    `Показаны первые 300 результатов из ${count}. Измените запрос, чтобы получить более подходящие результаты поиска.`,
  searchResultsShowAll: 'Показать все',
  searchResults2:
    'Не найдено ни одной задачи, удовлетворяющей условиям фильтрации. Измените запрос или измените фильтр',
  searchResults3: 'Результаты поиска в других фильтрах:',

  addContactByEmail: 'Добавить контакт по e-mail',
  allDirectChats: 'Все чаты и контакты',
  feedbackTitle: 'Помощь по YouGile, новости',
  addFeedback: 'Добавить обращение',
  fbOpen: 'Открытые',
  fbClosed: 'Закрытые',
  fbTitle: 'Заголовок',
  fbMessage: 'Сообщение',
  fbAddRequest: 'Добавить обращение',
  profilePath: 'Личные сообщения »',
  feedbackPath: 'Обратная связь »',
  mspSuccess: 'Настройки e-mail успешно сохранены',
  mailReply: 'Ответить в YouGile',
  mailSettingsHead: 'Настройки e-mail для',
  mspGetNews: 'получать новости об обновлениях сервиса',
  mspGetNotifications: 'получать уведомления о новых сообщениях в чатах',
  mspNotifyOften: 'без ограничений (по умолчанию)',
  mspNotifyHourly: 'не более 1 письма о пропущенных сообщениях в час',
  mspNotifyDaily: 'не более 1 письма о пропущенных сообщениях в день',
  noConnectionShort:
    'Невозможно получить ответ от сервера, ' +
    'проверьте подключение к интернету.',
  noConnection:
    'Невозможно получить ответ от сервера, ' +
    'проверьте подключение к интернету. После восстановления соединения ' +
    'изменения будут отправлены на сервер.',
  removeLastAdminWarn:
    'Невозможно удалить последнего администратора в компании. ' +
    'Назначьте сначала администратором другого пользователя.',
  addedUsers: (count: number): string => `Добавлено пользователей: ${count}.`,
  removedUsers: (count: number): string => `Удалено пользователей: ${count}.`,
  noChangesUsers: 'Нет изменений. Выберите пользователей справа.',
  sprintStickerAutoSort: 'Состояния стикера “Sprint” сортируются автоматически',
  egBoard: 'Тестовая доска',
  egCol1: 'Обучающие задачи',
  egCol2: 'Самое важное',
  egT1: 'Зарегистрироваться',
  egT2: 'Создайте новый проект',
  egT3: 'Создайте новую доску',
  egT4: 'Добавьте участника к проекту на странице проектов',
  egT5: 'Напишите любое сообщение в чат',
  egT6: 'Отметьте эту задачу стикером приоритета “Major”',
  egT7: 'Добавьте новую задачу',
  egT8: 'Перетащите эту задачу в колонку справа',
  egT9: 'Добавьте новую колонку',
  egT10: 'Отметьте эту задачу как выполненную',
  egMsg: `
        Привет! Каждая задача в YouGile – это чат.
        Все коммуникации в вашей команде теперь будут хорошо структурированы.

        Добро пожаловать в YouGile!
      `,
  tasks: 'Задачи',
  taskChats: 'Чаты задач',
  personalChats: 'Личные',
  settings: 'Настройки',
  settingsAndBg: 'Настройки / Смена фона',
  profile: 'Профиль',
  edit: 'Редактировать',
  writeMessage: 'Напишите сообщение',
  willReceiveNotificationsPlural: 'Получат уведомления',
  online: 'в сети',
  offline: 'не в сети',
  changeName: 'Сменить имя',
  changePassword: 'Сменить пароль',
  changeAvatar: 'Сменить аватару',
  generalPlural: 'Общие',
  disableNotifications: 'Отключить уведомления',
  enabledPlural: 'Включены',
  disabledPlural: 'Отключены',
  postOnEnter: 'Посылать по Enter',
  myChats: 'чаты со мной',
  otherChats: 'другие чаты',
  emptyOtherChatsNotice: LangUtil.stripMargin(`
    Сейчас здесь ничего нет
    Ничего страшного :)

    В будущем здесь будут чаты ваших коллег, где вас не включили в нотификацию
  `),
  emptyPersonalChatsNotice: LangUtil.stripMargin(`
    Пусто!
    Вы ещё не с кем не общались лично.

    Почему бы не начать прямо сейчас!
  `),
  language: 'Язык',
  createQuickLink: 'Создать быструю ссылку',
  editQuickLink: 'Редактировать быструю ссылку',
  enterQuickLink: 'Введите название быстрой ссылки',
  noConnectionMobile: 'Нет соединения с интернетом',
  noServer: 'Сервер не отвечает',
  reconnect: 'подключиться еще раз',
  createProject: 'Создать проект',
  projectName: 'Название проекта',
  idProject: 'Префикс ID задачи',
  idProjectBusy: 'Проект с таким ID уже существует',
  idProjectBusyBySystem: 'Префикс ID уже занят',
  idProjectInvalid: 'Только латинские буквы и цифры',
  unread: 'Непрочитанные',
  stickersFiltration: 'Фильтрация стикеров',
  filtration: 'Фильтрация',
  customizeTable: 'Настроить таблицу',
  noTasks: 'Задач в списке нет',
  emptyTasksList: 'Список пуст. Создайте (+) или перетащите сюда задачу',
  tasksNotFoundByFilters:
    'Не найдено ни одной задачи, удовлетворяющей условиям фильтрации. Сбросьте фильтры',
  tasksListAvailableOnlyForYou: 'Список виден только вам',
  tasksListAvailableOnlyForYouHint:
    'Приватные задачи видны только вам, другие пользователи не могут их найти или открыть.',
  availableTableColumns: 'Доступные столбцы таблицы',
  filter: 'Фильтр',
  filterBySticker: 'Фильтровать',
  rename: 'Переименовать',
  renameId: 'Изменить префикс ID проекта',
  delete: 'Удалить',
  bind: 'Связать',
  openChat: 'Открыть чат',
  confirmDeleteGroup: 'Вы действительно хотите удалить эту колонку?',
  confirmation: 'Подтверждение',
  deleteListWithTasks: 'Удалить список с задачами',
  deleteListWithTasksConfirmation:
    'При удалении списка все задачи в нем тоже будут удалены. Продолжить удаление?',
  error: 'Ошибка',
  openEdit: 'Открыть / Изменить',
  currentCompany: 'Текущая компания',
  changeCompanyLabel: 'Сменить компанию',
  doNotDisturbMode: 'Режим "Не беспокоить" (DnD)',
  doNotDisturb: 'Не беспокоить',
  notificationsAndSounds: 'Уведомления и звуки',
  notifications: 'Уведомления',
  shakeForFeedback: 'Потрясти для обратной связи',
  feedbackAndHelp: 'Обратная связь и помощь',
  disabled: 'Выключено',
  enabled: 'Включено',
  profileUpdateSuccessful: 'Ваш профиль был успешно обновлен',
  title: 'Заголовок',
  problemDescription: 'Описание проблемы',
  messageSent: 'Сообщение выслано',
  thanksMessageSent: 'Спасибо, ваше сообщение передано разработчикам',
  openTickets: 'Текущие обращения',
  closedTickets: 'Закрытые обращения',
  attachFile: 'Прикрепить файл к сообщению',
  addGroup: 'Добавить колонку',
  enterProjectName: 'Введите название проекта',
  enterBoardName: 'Введите название доски',
  enterGroupName: 'Введите название колонки',
  enterTaskName: 'Введите название задачи',
  selectCompany: 'Выбор компании',
  createBoard: 'Создать доску',
  deleteBoard: 'Удалить доску',
  renameBoard: 'Переименовать доску',
  done: 'Готово',
  clean: 'Очистить',
  emptyProjectNotice: (name: string) => {
    return `В вашем проекте "${name}" нет ни одной доски.`
  },
  addToProject: 'Добавить в проект',
  emailGreeting: (name: string): string => `Здравствуйте, ${name}.\n`,
  unseenSubject: (date: string): string =>
    `Новые непрочитанные сообщения (${date}) `,
  unseenPreview: (count: number, chats: number): string =>
    `сообщений: ${count}, чатов: ${chats}`,
  unseenText1: (count: number, chats: number): string =>
    `У вас ${count} непрочитанных сообщений (в ${chats} чатах):`,
  unseenText11: 'У вас ',
  unseenText12: (chats: number): string =>
    ` непрочитанных сообщений (в ${chats} чатах):`,
  resetPasswordSubject: 'Восстановление пароля',
  resetPasswordPreview: 'Перейдите по [ссылке], чтобы установить новый пароль',
  resetPassText1:
    'Было запрошено восстановление пароля для вашего аккаунта ' + 'YouGile',
  resetPassText2: 'Чтобы установить новый пароль, перейдите по',
  resetPassText3: 'этой ссылке',
  resetPasswordTextBody: (name: string, url: string): string =>
    LangUtil.stripMargin(`
    Здравствуйте, ${name}.

    Было запрошено восстановление пароля для вашего аккаунта YouGile.
    Чтобы установить новый пароль, воспользуйтесь ссылкой:
    ${url}
  `),
  emailTextFooter: (unsubscribeLink: string): string =>
    LangUtil.stripMargin(`
    --
    С уважением,
    команда YouGile.


    (Чтобы отписаться от писем YouGile, пройдите по ссылке:
     ${unsubscribeLink})
  `),
  changeCompany(name: string): string {
    return `Изменить настройки компании “${name}”`
  },
  taskNoun: {
    one: 'задача',
    few: 'задачи',
    many: 'задач'
  } as PluralNoun,
  // accusative case
  taskNounAcc: {
    one: 'задачу',
    few: 'задачи',
    many: 'задач'
  } as PluralNoun,
  triesNoun: {
    one: 'попытка',
    few: 'попытки',
    many: 'попыток'
  } as PluralNoun,
  messageNoun: {
    one: 'сообщение',
    few: 'сообщения',
    many: 'сообщений'
  } as PluralNoun,
  newNoun: {
    one: 'новое',
    few: 'новых',
    many: 'новых'
  } as PluralNoun,
  newNounFemale: {
    one: 'новая',
    few: 'новые',
    many: 'новых'
  } as PluralNoun,
  fileNoun: {
    one: 'файл',
    few: 'файла',
    many: 'файлов'
  } as PluralNoun,
  dayNoun: {
    one: 'день',
    few: 'дня',
    many: 'дней',
    other: 'дня'
  } as PluralNoun,
  hourNoun: {
    one: 'час',
    few: 'часа',
    many: 'часов',
    other: 'часа'
  } as PluralNoun,
  minuteNoun: {
    one: 'минута',
    few: 'минуты',
    many: 'минут',
    other: 'минуты'
  } as PluralNoun,
  remainedNoun: {
    one: 'остался',
    few: 'осталось',
    many: 'осталось',
    other: 'осталось'
  } as PluralNoun,
  personNoun: {
    one: 'человек',
    few: 'человека',
    many: 'человек',
    other: 'человек'
  } as PluralNoun,
  companyNoun: {
    one: 'компания',
    few: 'компаний',
    many: 'компаний',
    other: 'компаний'
  } as PluralNoun,
  boardNoun: {
    one: 'доска',
    few: 'доски',
    many: 'досок',
    other: 'досок'
  } as PluralNoun,
  projectNoun: {
    one: 'проект',
    few: 'проекта',
    many: 'проектов',
    other: 'проектов'
  } as PluralNoun,
  ratingNoun: {
    one: 'оценка',
    few: 'оценки',
    many: 'оценок',
    other: 'оценок'
  } as PluralNoun,
  commentNoun: {
    one: 'комментарий',
    few: 'комментария',
    many: 'комментариев',
    other: 'комментариев'
  } as PluralNoun,
  ratingsCount(count: number): string {
    return `${count} ${langRu.ratingNoun[plural('ru', count)]}`
  },
  commentsCount(count: number): string {
    return `${count} ${langRu.commentNoun[plural('ru', count)]}`
  },
  selectedCompanies(companies: number): string {
    return `${companies} ${langRu.companyNoun[plural('ru', companies)]}`
  },
  selectedBoards(boards: number): string {
    return `${boards} ${langRu.boardNoun[plural('ru', boards)]}`
  },
  selectedProjects(projects: number): string {
    return `${projects} ${langRu.projectNoun[plural('ru', projects)]}`
  },
  projectTasks(tasks: number): string {
    return `${tasks} ${langRu.taskNoun[plural('ru', tasks)]}`
  },
  newTasks(tasks: number): string {
    return `${tasks} ${langRu.newNounFemale[plural('ru', tasks)]} ${
      langRu.taskNoun[plural('ru', tasks)]
    }`
  },
  newMessages(messages: number): string {
    return `${messages} ${langRu.newNoun[plural('ru', messages)]} ${
      langRu.messageNoun[plural('ru', messages)]
    }`
  },
  projectMessages(messages: number): string {
    return `${messages} ${langRu.messageNoun[plural('ru', messages)]}`
  },
  projectNewMessages(messages: number): string {
    return `${messages} ${langRu.newNoun[plural('ru', messages)]}`
  },
  projectFiles(files: number): string {
    return `${files} ${langRu.fileNoun[plural('ru', files)]}`
  },
  projectStats(tasks: number, messages: number, files: number): string {
    return (
      `${langRu.projectTasks(tasks)}, ` +
      `${langRu.projectMessages(messages)}, ${langRu.projectFiles(files)}.`
    )
  },
  deadlineNoticeDays(days: number): string {
    return `До дедлайна осталось: ${days} ${
      langRu.dayNoun[plural('ru', days)]
    }!`
  },
  deadlineNoticeHours(hours: number): string {
    return (
      `До дедлайна ${langRu.remainedNoun[plural('ru', hours)]} ${hours} ` +
      `${langRu.hourNoun[plural('ru', hours)]}!`
    )
  },
  deadlineNoticeMinutes(minutes: number): string {
    return (
      `До дедлайна ${langRu.remainedNoun[plural('ru', minutes)]} ${minutes} ` +
      `${langRu.minuteNoun[plural('ru', minutes)]}!`
    )
  },
  severalMinutes(minutes: number): string {
    return `${minutes} ${langRu.minuteNoun[plural('ru', minutes)]}`
  },
  severalHours(hours: number): string {
    return `${hours} ${langRu.hourNoun[plural('ru', hours)]}`
  },
  severalDays(days: number): string {
    return `${days} ${langRu.dayNoun[plural('ru', days)]}`
  },
  deadlineAlert: 'Дедлайн по задаче был просрочен',
  dateNotSet: 'Не выбрана дата',
  settingDeadline: 'Установка дедлайна',
  at: 'к',
  saved: 'Сохранено!',
  notifyBefore: 'Напомнить за',
  withTime: 'Добавить время',
  goToTask: 'Перейти к задаче',
  projectsAndTasksHeader: 'Проекты и задачи',
  taskChatsHeader: 'Чаты по задачам',
  userWrote: (name: string) => name + ' написал(а):',
  registerEmailText(inviter: string, url: string, text: string): string {
    if (text) {
      return LangUtil.stripMargin(`
        Пользователь ${inviter} пригласил(а) вас в проект.

        ${inviter} написал(а):
        “${text}”

        Чтобы посмотреть и редактировать проект перейдите по ссылке ниже:
        ${url}
      `)
    } else {
      return LangUtil.stripMargin(`
        Пользователь ${inviter} пригласил(а) вас в проект.

        Чтобы посмотреть и редактировать проект перейдите по ссылке ниже:
        ${url}
      `)
    }
  },
  registerText1: (inviter: string): string =>
    `Пользователь ${inviter} пригласил(а) вас в проект.`,
  registerText2: 'Чтобы посмотреть и редактировать проект перейдите по',
  registerText3: 'этой ссылке',
  emailReason: `Вы получили это письмо, потому что зарегистрированы в YouGile`,
  setupMail: 'Настройки e-mail оповещений YouGile',
  unsubscribe: 'Отписаться от писем YouGile',
  inviteReason: (inviterEmail: string): string => `
    Вы получили это письмо по приглашению пользователя с e-mail ${inviterEmail}
  `,
  inviteCompanySubject: (companyName: string) =>
    `Вы приглашены в компанию “${companyName}”`,
  inviteCompanyPreview: 'Новый проект доступен в вашем аккаунте',
  inviteCompanyEmailText(
    inviter: string,
    url: string,
    companyTitle: string,
    text: string
  ): string {
    if (text) {
      return LangUtil.stripMargin(`
        Пользователь ${inviter} добавил(а) вас в качестве участника в компанию
        “${companyTitle}”.

        ${inviter} написал(а):
        “${text}”

        Новая компания теперь есть в списке компаний вашего аккаунта YouGile
        ${url}.
      `)
    } else {
      return LangUtil.stripMargin(`
        Пользователь ${inviter} добавил(а) вас в качестве участника в компанию
        “${companyTitle}”.

        Новая компания теперь есть в списке компаний вашего аккаунта YouGile
        ${url}.
      `)
    }
  },
  inviteText1: (inviter: string, companyTitle: string): string =>
    `Пользователь ${inviter} добавил(а) вас в качестве участника в компанию
        “${companyTitle}”.`,
  inviteText2: 'Новая компания теперь есть в списке компаний вашего',
  inviteText3: 'аккаунта YouGile',
  registerPartnerSubject: 'Регистрация в партнёрской программе YouGile',
  registerPartnerText:
    'Чтобы продолжить регистрацию в партнёрской программе YouGile, пройдите по ссылке ниже:',
  registerPartnerEmailText(link: string): string {
    return LangUtil.stripMargin(`
        Чтобы продолжить регистрацию в партнёрской программе YouGile,
        пройдите по ссылке: ${link}
      `)
  },
  registerRequestEmailText(link: string): string {
    return LangUtil.stripMargin(`
        Чтобы продолжить регистрацию YouGile,
        пройдите по ссылке: ${link}
      `)
  },
  registerRequestEmailSubject: 'Регистрация в YouGile',
  registerButtonText: 'Продолжить регистрацию',
  registerRequestText:
    'Чтобы продолжить регистрацию YouGile, пройдите по ссылке ниже:',
  boxRequestEmailText(link: string, os: string, docsLink: string): string {
    return LangUtil.stripMargin(`
      Ссылка на скачивания установщика (${os}) коробочной версии:
      ${link}

      Документация по установке:
      ${docsLink}
    `)
  },
  boxRequestLinuxEmailText(
    rhelLink: string,
    debianLink: string,
    instructionsLink: string
  ): string {
    return LangUtil.stripMargin(`
      Для RHEL, CentOS, CloudLinux используйте следующую ссылку для
      скачивания установщика:
      ${rhelLink}

      Для Debian, Ubuntu и других дистрибутивов используйте ссылку:
      ${debianLink}

      Документация по установке:
      ${instructionsLink}
    `)
  },

  changeEmailPrevSubject: 'Изменение почты',
  changeEmailPrevPreview: 'Изменение почты',
  changeEmailPrevText1: (name: string, newEmail: string): string =>
    `Добрый день, ${name}! В вашем аккаунте YouGile был изменен e-mail адрес на ${newEmail}.`,
  changeEmailPrevText2:
    'Если вы не меняли почту, свяжитесь с тех. поддержкой: support@yougile.com',
  changeEmailPrevTextBody: (name: string, newEmail: string): string =>
    LangUtil.stripMargin(`
    Добрый день, ${name}! В вашем аккаунте YouGile был изменен e-mail адрес на ${newEmail}.
    Если вы не меняли почту, свяжитесь с тех. поддержкой: support@yougile.com
    `),
  changeEmailNewSubject: 'Изменение почты',
  changeEmailNewPreview: 'Изменение почты',
  changeEmailNewText1: (name: string): string =>
    `Добрый день, ${name}! Для изменения почты `,
  changeEmailNewText2: 'перейдите по ссылке',
  changeEmailNewTextBody: (name: string, link: string) =>
    `Добрый день, ${name}! Для изменения почты перейдите по ссылке: ${link}`,

  boxRequestEmailSubject: 'Коробочная версия',
  boxRequestText: 'Ссылка для скачивания установщика:',
  boxRequestText2: 'Документация по установке:',
  boxRequestText3:
    'Документация для написания расширений на YouGile Платформе:',
  scripts: 'Скрипты',
  addScriptHint: 'Добавить новый скрипт',
  uploadScriptHint: 'Загрузить скрипт с компьютера',
  runScriptHint: 'Запустить/перезагрузить скрипт локально',
  saveScriptHint: 'Сохранить скрипт',
  enabledScriptHint:
    'Скрипт запускается при загрузке страницы ' + 'для всех пользователей',
  disabledScriptHint: 'Скрипт не запускается при загрузке страницы',
  yourScripts: 'Ваши скрипты',
  scriptNamePlaceholder: 'Введите имя скрипта …',
  noScripts1: 'Пока нет скриптов,',
  noScripts2: 'добавить скрипт',
  openScriptHint: 'Открыть скрипт',
  enabledScript: 'включен',
  disabledScript: 'выключен',
  addMarketplace: 'Добавить в маркетплейс',
  renameScript: 'Переименовать скрипт',
  scriptPresets: 'Примеры скриптов',
  approvedScript: 'подтверждён',
  notApprovedScript: 'не подтверждён',
  notAssigned: 'Не назначено',
  apiNavigator: 'Навигатор по API',
  objectNavigator: 'Навигатор по объектам',
  apiHelp: 'Помощь',
  helpTitle: 'Помощь',
  insertToCode: 'Вставить в редактор',
  editInScript: 'скопировать в редактор',
  usageExample: 'Пример использования',
  openEditorWarn: 'Сначала откройте скрипт, куда вы хотите вставить этот код',
  onlyJsAllowed: 'Поддерживаются только файлы с расширением .js',
  confirmAddMarketplace: 'Действительно добавить этот скрипт в маркетплейс?',
  confirmDeleteScript: (name: string) => `Удалить скрипт “${name}”?`,
  confirmCloseUnsaved:
    'У вас есть несохранённые изменения в скрипте. ' +
    'Сбросить изменения и зарыть вкладку?',
  objNavHint: 'Объекты можно перетаскивать мышкой в редактор',
  helpWriteUs1: 'Напишите нам в чат',
  helpWriteUs2: `
    — вы можете создать чат с нами,
    мы рады услышать ваше мнение
    и готовы помочь в решении проблем / багов.`,
  helpWatchVid1: 'Посмотрите видео',
  helpWatchVid2: `
    — в этом 10-минутном видео показаны примеры
    реализации скриптов, решающих конкретные задачи.`,
  helpReadMan1: 'Прочтите мануал (pdf)',
  helpReadMan2: `
    — короткий мануал в несколько станиц, который может
    помочь вам лучше понять как устроено API YouGile.`,
  apiAppCopy: 'копировать в свои скрипты',
  readonlyScriptWarn:
    'Только для чтения. ' + 'Скопируйте к себе, чтобы редактировать.',
  deleteMsg: 'Удалить сообщение',
  reactMsg: 'Реагировать на сообщение',
  confirmDeleteBg: 'Удалить этот фон?',
  newCompanyAvailable:
    'Доступна новая компания, после перезагрузки вы сможете ' +
    'выбрать новую компанию в списке компаний.',
  mobileAppBannerTitle: 'Мобильное приложение 2.0',
  mobileAppBannerTitleAdmin: 'С приложением команда включается в работу',
  mobileAppBannerTextAdmin: 'быстрее — доказано опытом 10 000 компаний',
  mobileAppBannerTitleNotAdmin: 'Теперь еще удобнее вести задачи',
  mobileAppBannerTextNotAdmin: 'и общаться в чатах',
  androidApp: 'Мобильное приложение',
  androidAppDetails: 'iOS и Android. Скачать »',
  androidAppTitle: 'Мобильное приложение YouGile доступно для iOS и Android.',
  androidAppText1:
    'Позволяет эффективно строить общение в команде вокруг задач, ' +
    'где бы вы ни находились. Простая работа с досками, ' +
    'мгновенные уведомления по вашим задачам, ' +
    'приватные личные сообщения — все необходимое для эффективной работы.',
  androidAppText2: 'Работайте свободно!',
  androidAppDownload: 'Скачать на Google Play',
  androidAppDownloadApple: 'Скачать в App Store',
  androidAppBtn1: 'Не показывать больше',

  desktopApp: 'Десктоп приложение',
  desktopAppDetails: 'Win, Mac, Linux. Скачать »',
  desktopAppBtn: 'Не показывать больше',
  desktopAppTitle: 'Скачать приложение YouGile',

  noDeleteLastBoard:
    'Нельзя удалить последнюю доску в проекте. ' +
    'Добавьте сначала новую доску, чтобы удалить эту.',
  addChecklist: 'Создать чеклист',
  checklistPlaceholder: 'Название списка подзадач…',
  sureDeleteChecklist: 'Удалить чек-лист?',
  sureDeleteChecklistHint:
    'При удалении чек-листа будут также удалены все пункты в нём',
  addSubtask: 'Добавить пункт',
  subtaskPlaceholder: 'Текст подзадачи…',
  checklistItemPlaceholder: 'Текст пункта…',
  checklistDel: 'Удалить список',
  checklistItemDel: 'Удалить подзадачу',
  checklistItemDelIssue: 'Удалить пункт',
  connectTaskWith: 'Добавить ссылку',
  unlink: 'Убрать',
  editNotSaved1: 'Вы не сохранили изменения. ',
  editNotSaved2: ' или ',
  editNotSaved3: '?',
  editSee: 'Посмотреть изменения',
  editDiscard: 'Отменить',
  newsTitle: 'Новости и обновления',
  addNewsItem: 'Добавить новость',
  newsColumnHint:
    'В этой колонке мы публикуем информацию по обновлениям и новости. ' +
    'Все обсуждения публичны, в отличие от персональных запросов в поддержку.',
  newsChatVisibility: 'Этот чат виден всем пользователям системы YouGile',
  prjParticipants: 'Пользователи в проекте',
  fullUserList: 'Показать ещё...',
  chooseUserFromLIst: 'Выбрать из списка пользователей',
  addUserByEmail: 'Пригласить по e-mail',
  enterEmailsToInvite: 'Введите e-mail-ы приглашаемых',
  inviteEmailIncorrect: 'Неверный e-mail, приглашение не будет отправлено',
  inviteEmailExists: 'Пользователь уже приглашён, вышлем повторное приглашение',
  addStickerHint: 'Добавить стикер',
  enterBoxUrl: 'Ввести адрес своего сервера\n(для коробочных версий)',
  enterBoxUrlError: 'Неверный формат адреса сервера',
  boxUrlIs(url: string): string {
    return `Адрес сервера: ${url}`
  },
  recoveryInvalidLink: 'Ссылка, по которой вы перешли больше не действительна.',
  recoveryTitle: 'Сброс пароля',
  recoveryNewPass: 'Новый пароль',
  recoveryNewPassPl: 'Введите новый пароль…',
  recoveryRetypePass: 'Новый пароль ещё раз',
  recoveryRetypePassPl: 'Повторите новый пароль…',
  recoveryChangePass: 'Изменить пароль',
  recoveryPassEmpty: 'Пароль не должен быть пустым',
  recoveryPassShort: 'Пароль должен быть не менее 3 символов',
  recoveryPassNoMatch: 'Пароли не совпадают',
  recoveryError: 'Возникла ошибка, попробуйте позже ещё раз',
  recoveryUnknownError: 'Неизвестная ошибка',
  registerTitle: 'Создать аккаунт',
  filtering: 'фильтрация',
  filterHint: 'Выберите значение стикера, чтобы отфильтровать доску',
  chooseDates: 'выберите даты',
  editorCloseConfirm:
    'У вас есть несохранённые изменения. Вы действительно' +
    'хотите закрыть эту вкладку? Все последние изменения будут потеряны.',
  stats: 'Статистика',
  ttEstimation: 'План',
  ttSpent: 'Факт',
  ttEnterEstimation: 'Введите план',
  ttLeaveNoPlan: 'Оставить без оценки',
  ttFillToClose: 'Необходимо заполнить поле',
  ttClosedIf: 'Задачи закрыты, если находятся в колонке',
  ttExcludeIf: 'Исключить колонку из таймтрекинга',
  newTasks1: '',
  newTasks2: ' новых задач в этой доске.',
  tsTasksRemain: 'Задач осталось',
  tsTasksClosed: 'Задач закрыто',
  tsHoursRemain: 'Часов осталось',
  tsHoursClosed: 'Часов закрыто',
  tsOpen: 'Открытые',
  tsClosed: 'Закрытые',
  tsAll: 'Все задачи',
  tsUser: 'User',
  tsTaskName: 'Название задачи',
  up: 'Наверх',
  tsPlan: 'План',
  tsWork: 'Факт',
  tsCreated: 'Создано',
  tsCloseDate: 'Закрыто',
  tsDownloadXLSX: 'Скачать в формате Excel',
  tsStats: 'Статистика…',
  tsTaskCount: 'Кол-во задач',
  tsTaskHours: 'Часов плана',
  tsKeyOpen: 'открытые',
  tsKeyClosed: 'закрытые',
  tsRange: 'Период',
  tsTitle: 'Статистика',
  connections: 'Связи',
  wantToDeleteATask: 'Удалить задачу?',
  wantToDeleteAMirror: 'Удалить зеркало задачи?',
  dateFormat: 'DD/MM/YY',
  timeFormat: 'hh:mm',
  yesterday: 'Вчера',
  todayFormat: 'Сегодня, hh:mm',
  yesterdayFormat: 'Вчера, hh:mm',
  you: 'Вы',
  search: 'Поиск',
  searchCompany: 'Поиск по компании',
  closeSearch: 'Закрыть поиск',
  duplicate: 'Дублировать',
  allProjectsAndPermissions: 'Все проекты и права',
  groupChats: 'Групповые чаты',
  uploadFile: 'Загрузить файл',
  uploadImage: 'Загрузить картинку',
  actionWithMessage: 'Действие с сообщением',
  copy: 'Скопировать',
  pin: 'Закрепить',
  newGroup: 'Новая колонка',
  newBoard: 'Новая доска',
  newTask: 'Новая задача',
  sendToChat: 'Отправить в чат',
  subtasks: 'Подзадачи',
  yourCompanies: 'Ваши компании',
  chatWithUser: 'Чат с пользователем',
  notFound: 'Не найдено',
  addUser: 'Пригласить сотрудников',
  addingUsers: 'Приглашение сотрудников',
  editUsers: 'Редактировать пользователей',
  askRemoveAdmin:
    'Вы уверены, что хотите убрать пользователя из администраторов?',
  askAddAdmin: 'Вы уверены, что хотите сделать пользователя администратором?',
  success: 'Успешно',
  noProjectsChosenError:
    'Выберите хотя бы один проект, куда будет добавлен пользователь',
  noUsersChosenError: 'Выберите хотя бы одного пользователя',
  deleteUser: 'Удалить сотрудника из компании?',
  operationUnavailable: 'Операция не доступна',
  newProject: 'Создание нового проекта',
  myChatsFilter: 'Чаты на которые вы подписаны',
  otherChatsFilter: 'Чаты на которые вы не подписаны',
  assignedToMeChatsFilter: 'Только задачи, назначенные на вас',
  emptyChatsFilter: 'Без сообщений',
  personalChatsFilter: 'Личные чаты',
  setupCompanies: 'Настройка компаний…',
  boardBackground: ' Фон досок',
  videoTutorialTitle: 'Обучение YouGile за 10 минут',
  reloadScriptsForAllUsers:
    'Перезагрузить скрипты у всех пользователей в компании',
  reloadScriptsConfirm:
    'Вы действительно хотите перезагрузить ' +
    'скрипты у всех пользователей в компании?',
  showOtherUsers: 'Показать остальных пользователей…',
  usersNotInProject: 'Пользователи не в проекте',
  download: 'Скачать',
  forWin: 'YouGile для Windows',
  forMac: 'YouGile для Mac OS X',
  forLinux: 'YouGile для Linux (x64)',
  goUp: 'вверх',
  move: 'Переместить',
  specifyDestination: 'Указать место назначения...',
  createTaskMovementRule: 'Создать правило для передачи задач...',
  boards: 'Доски',
  columns: 'Колонки',
  chosenColumns: 'Выбранные колонки',
  newMsgInOtherCompanies: 'Новые сообщения в других компаниях',
  newColumn: 'Новая колонка',
  stickerPriority: 'Приоритет',
  majorPrio: 'Важно',
  normalPrio: 'Нормально',
  minorPrio: 'Не важно',
  largeColumn: 'В колонке более 1000 задач, она не будет скопирована',
  confirmDuplicateProject: 'Вы действительно хотите дублировать этот проект?',
  companyAdded: 'Компания успешно создана',
  unnamed: 'Без названия',
  collapseBoardHeader: 'Свернуть шапку доски',
  addFirstTask: 'Добавьте первую задачу',
  onboardingVideo1: 'Поздравляем с первым шагом!',
  onboardingVideo2: 'Есть ещё 92 функции:',
  onboardingVideo3: '92 функции за 11 минут',
  onboardingNoTasks1: 'Чаты',
  onboardingNoTasks2: 'Это список ваших чатов.',
  onboardingNoTasks2_5:
    'Пока тут пусто — вы не создали ни одной задачи и не пригласили коллег.',
  onboardingNoTasks3: 'Создайте задачу',
  onboardingNoTasks4: 'или',
  onboardingNoTasks5: 'пригласите сотрудников в вашу компанию',
  onboardingNoUsers1: 'Список пользователей пока пуст.',
  onboardingNoUsers2: 'Добавьте коллег!',
  onboardingSingleTask1: 'Отлично, вы создали первую задачу!',
  onboardingSingleTask2: 'Щелкните на неё, чтобы открыть чат по ней',
  closeWnd: 'Закрыть окно',
  permissionsSetupGeneral: 'Общие настройки',
  permissionsObjectExists: 'Этот объект уже добавлен в группу',
  permissionsChooseProject: 'Выберите проект',
  permissionsObjectsHeader: 'Объект системы',
  permissionsObjectSettingsHeader: 'Права доступа к выбранному объекту',
  permissionsUsersSave: 'Сохранить список пользователей',
  permissionsFullAccess: 'Полный доступ',

  permissionsForbiddenProjectDelete:
    'Удаление этого проекта вам запрещено. ' +
    'Обратитесь к администратору вашей компании.',
  permissionsForbiddenBoardDelete:
    'Удаление этой доски вам запрещено. ' +
    'Обратитесь к администратору вашей компании.',
  permissionsForbiddenColumnDelete:
    'Удаление этой колонки вам запрещено. ' +
    'Обратитесь к администратору вашей компании.',
  permissionsForbiddenTaskDelete:
    'Удаление этой задачи вам запрещено. ' +
    'Обратитесь к администратору вашей компании.',
  permissionsForbiddenRename:
    'У вас недостаточно прав для изменения этого названия. ' +
    'Обратитесь к администратору вашей компании.',
  permissionsForbiddenMove:
    'У вас недостаточно прав для перемещения этого объекта. ' +
    'Обратитесь к администратору вашей компании.',

  permissionsForbiddenCreateMirrorP1:
    'Перетаскивание задачи из сводки создаёт зеркало задачи.',
  permissionsForbiddenCreateMirrorP2:
    'У вас нет прав на создание зеркала на доске, где находится задача. Обратитесь к администратору системы.',
  permissionsForbiddenCreateMirrorFromSubtaskP1:
    'Перетаскивание задачи из сводки создаёт зеркало задачи.',
  permissionsForbiddenCreateMirrorFromSubtaskP2:
    'Нельзя создать зеркало из подзадачи без доски. Чтобы создать зеркало, переместите подзадачу на доску, затем создайте зеркало.',

  notSupportDragFromReportsP1:
    'Перетаскивание задачи из сводки создаёт зеркало задачи.',
  notSupportDragFromReportsP2:
    'Создание зеркала задачи из сводной колонки не поддерживается Вашей версией сервера',

  permissionsForbiddenEditDescription:
    'У вас недостаточно прав для редактирования этого описания. ' +
    'Обратитесь к администратору вашей компании.',
  permissionsForbiddenTaskClose:
    'У вас недостаточно прав для архивирования этой задачи. ' +
    'Обратитесь к администратору вашей компании.',
  permissionsForbiddenAssignUser:
    'У вас недостаточно прав для назначения этого пользователя в эту задачу. ' +
    'Обратитесь к администратору вашей компании.',
  permissionsForbiddenTaskStickers:
    'У вас недостаточно прав для изменения стикеров в этой задаче. ' +
    'Обратитесь к администратору вашей компании.',
  permissionsForbiddenTaskConnect:
    'У вас недостаточно прав для связывания этих задач. ' +
    'Обратитесь к администратору вашей компании.',
  permissionsFobiddenTaskComplete:
    'У вас недостаточно прав для изменения выполненности этой задачи',
  permissionsForbiddenEditSubtasks:
    'У вас недостаточно прав для изменения подзадач этой задачи. ' +
    'Обратитесь к администратору вашей компании.',
  permissionsForbiddenSendFiles:
    'У вас недостаточно прав для отправки файлов в этом чате. ' +
    'Обратитесь к администратору вашей компании.',
  permissionsForbiddenEditWhoToNotify:
    'У вас недостаточно прав для изменения нотификации этого пользователя ' +
    'в этом чате. ' +
    'Обратитесь к администратору вашей компании.',

  cannotMoveTaskColumnDeleted:
    'Невозможно переместить задачу, так как колонка для перемещения была удалена. Отредактируйте правило',

  cannotMoveTaskBoardDeleted:
    'Невозможно переместить задачу, так как доска для перемещения была удалена. Отредактируйте правило',

  cannotMoveTaskProjectDeleted:
    'Невозможно переместить задачу, так как проект для перемещения был удален. Отредактируйте правило',

  taskIsOutOfFilters:
    'Чтобы увидеть созданную задачу, отключите фильтрацию доски',

  permissionsProject: 'Проект',
  permissionsBoard: 'Доска',
  permissionsColumn: 'Колонка',
  permissionsTask: 'Задача',
  permissionsAllowAll: 'Разрешить всё',
  permissionsDisallowAll: 'Запретить всё',

  permissionsSettingsProjectDelete: 'Удаление проекта',
  permissionsSettingsProjectEditTitle: 'Изменение названия проекта',
  permissionsSettingsProjectAddBoard: 'Добавление доски',
  permissionsSettingsProjectBoards: 'Доски',

  permissionsSettingsBoardDelete: 'Удаление доски',
  permissionsSettingsBoardEditTitle: 'Изменение названия доски',
  permissionsSettingsBoardShowStickers: 'Отображение панели стикеров',
  permissionsSettingsBoardEditStickers: 'Изменение стикеров в доске',
  permissionsSettingsBoardMove: 'Перемещение доски',
  permissionsSettingsBoardAddColumn: 'Добавление колонки',
  permissionsSettingsBoardSettings: 'Управление основными настройками доски',
  permissionsSettingsBoardColumns: 'Колонки',

  permissionsSettingsColumnDelete: 'Удаление колонки',
  permissionsSettingsColumnEditTitle: 'Изменение названия колонки',
  permissionsSettingsColumnMove: 'Перемещение колонки',
  permissionsSettingsColumnMoveOptNo: 'Запретить',
  permissionsSettingsColumnMoveOptProject: 'Разрешить только внутри проекта',
  permissionsSettingsColumnMoveOptYes: 'Разрешить',
  permissionsSettingsColumnAddTask: 'Добавление задачи',
  permissionsSettingsColumnAllTasks: 'Все задачи',
  permissionsSettingsColumnWithMeTasks:
    'Задачи, где пользователь добавлен в уведомления',
  permissionsSettingsColumnMyTasks: 'Назначенные на пользователя задачи',
  permissionsSettingsColumnCreatedByMeTasks: 'Задачи, созданные пользователем',

  permissionsSettingsTaskShow: 'Просмотр задачи',
  permissionsSettingsTaskDelete: 'Удаление задачи',
  permissionsSettingsTaskEditTitle: 'Изменение названия задачи',
  permissionsSettingsTaskEditDescription: 'Изменение описания задачи',
  permissionsSettingsTaskComplete: 'Выполнение задач',

  permissionsSettingsTaskClose: 'Архивирование задачи',
  permissionsSettingsTaskAssignUsers: 'Назначение исполнителя',
  permissionsSettingsTaskAssignUsersOptNo: 'Запретить',
  permissionsSettingsTaskAssignUsersOptAddSelf:
    'Разрешить назначать себя, если не назначено',
  permissionsSettingsTaskAssignUsersOptSetSelf: 'Разрешить назначать себя',
  permissionsSettingsTaskAssignUsersOptChangeFromSelf:
    'Разрешить менять с себя на другого',
  permissionsSettingsTaskAssignUsersOptYes: 'Разрешить любые назначения',

  permissionsSettingsTaskConnect: 'Связывание задач',
  permissionsSettingsTaskEditSubtasks: 'Изменение чеклистов и списка подзадач',
  permissionsSettingsTaskEditSubtasksOptNo: 'Запретить',
  permissionsSettingsTaskEditSubtasksOptComplete:
    'Разрешить выполнять чеклисты',
  permissionsSettingsTaskEditSubtasksOptYes: 'Разрешить',
  permissionsSettingsTaskEditStickers: 'Изменение стикеров и цвета в задаче',
  permissionsSettingsTaskEditPins: 'Изменение быстрых ссылок в чате',
  permissionsSettingsTaskSendFiles: 'Отправка файлов в чате',
  permissionsSettingsTaskEditWhoToNotify:
    'Изменение списка “Получат уведомление”',
  permissionsSettingsTaskEditWhoToNotifyOptNo: 'Запретить',
  permissionsSettingsTaskEditWhoToNotifyOptSelf: 'Разрешить добавлять себя',
  permissionsSettingsTaskEditWhoToNotifyOptYes: 'Разрешить изменение списка',

  permissionsSettingsTaskMove: 'Перемещение задачи',
  permissionsSettingsTaskMoveOptNo: 'Запретить',
  permissionsSettingsTaskMoveOptBoard: 'Разрешить только внутри доски',
  permissionsSettingsTaskMoveOptProject: 'Разрешить только внутри проекта',
  permissionsSettingsTaskMoveOptYes: 'Разрешить',
  permissionsSettingsTaskSendMessages: 'Отправка сообщений в задаче',
  permissionsSettingsTaskSame: 'Как у остальных задач',
  permissionsSettingsTaskSameSpecify: 'Настроить',
  permissionsSettingsTaskSameReset: 'Сделать как у остальных задач',
  chooseObjectProject: 'Выберите проект',
  chooseObjectBoard: 'Выберите доску',
  chooseObjectColumn: 'Выберите колонку',
  chooseObjectTask: 'Выберите задачу',
  permissionsObjectProject: 'Проект',
  permissionsObjectBoard: 'Доска',
  permissionsObjectColumn: 'Колонка',
  permissionsObjectTask: 'Задача',
  permissionsObjectsEmptyHint<T>(
    normal: (s: string, key: string) => T,
    bold: (s: string, key: string) => T
  ): T[] {
    let ix = 0
    const n = (s: string) => normal(s, '' + ix++)
    const b = (s: string) => bold(s, '' + ix++)
    return [
      n('Добавьте '),
      b('проект'),
      n(', '),
      b('доску'),
      n(', '),
      b('колонку'),
      n(' или '),
      b('задачу'),
      n(', к которым надо настроить права доступа')
    ]
  },
  next: 'Далее',
  permissionsAddFirstObject:
    'Добавить объект для настройки прав доступа к нему',
  usersAndPermissions: 'Пользователи и права',
  permissionsHintTitle: 'Права и доступы пользователей',
  permissionsHintText: 'короткое и подробное видео про права',
  permissionsMenuItem: 'Права пользователей',
  newTasksNotification: (n: number) =>
    n +
    ' ' +
    (
      {
        one: 'новое',
        few: 'новых',
        many: 'новых'
      } as PluralNoun
    )[plural('ru', n)],
  daysLeftNoun: {
    one: 'день',
    few: 'дня',
    many: 'дней'
  } as PluralNoun,
  severalDaysSuff: (d: number) => langRu.daysLeftNoun[plural('ru', d)],
  daysLeft: (d: number) => d + ' ' + langRu.daysLeftNoun[plural('ru', d)],
  monthsLeftNoun: {
    one: 'месяц',
    few: 'месяца',
    many: 'месяцев'
  } as PluralNoun,
  monthsLeft: (m: number) => m + ' ' + langRu.monthsLeftNoun[plural('ru', m)],
  userCountNoun: {
    one: 'пользователь',
    few: 'пользователя',
    many: 'пользователей'
  },
  userCount: (u: number) => u + ' ' + langRu.userCountNoun[plural('ru', u)],
  buyLicense: 'Купить лицензию',
  billingMenuItem: 'Лицензия и оплаты',
  billingBannerYouUse: 'Вы используете ',
  billingBannerVersion: ' версию.',
  billingBannerStandardPlan: 'Стандарт',
  billingBannerYourTariff: 'Ваш тариф',
  billingStandardExpiresIn: 'Лицензия заканчивается через ',
  billingCurrentTariffPlan: 'Текущий тарифный план',
  billingBuyStandard: 'Лицензия “Standard”',
  billingDuration1: 'Лицензия на 1 месяц',
  billingDuration3: 'Лицензия на 3 месяца',
  billingDuration6: 'Лицензия на 6 месяцев',
  billingDuration12: 'Лицензия на 1 год',
  billingDuration24: 'Лицензия на 2 года',
  billingNumberOfUsers: 'Кол-во пользователей',
  billingPerUser: 'За пользователя',
  billingPerMonth: 'в месяц',
  billingTotal: 'Всего',
  billingYearGift:
    'При оплате за год — платите только за 10 мес. ' +
    '2 месяца в подарок, на отпуск и отгулы!',
  billingOpts: 'Варианты оплаты',
  billingCardOpt: 'Оплата картой',
  billingInvoiceOpt: 'Выставить счёт',
  billingPayment: 'Платёж',
  billingAutoRenew: 'Автоматическое продление',
  billingPay: 'Оплатить',
  billingGetInvoice: 'Выставить счёт',
  billingInvoiceSentReq:
    'Запрос направлен вашему менеджеру, с вами свяжутся в ближайшее время.',
  billingPageTitle: 'Лицензия и оплаты',
  billingBannerStandardDaysLeft: 'Дней до окончания',
  billingProlong: 'Продлить',
  billingYouGileInfo:
    'ООО “Юджайл”, ИНН 7725393915, КПП 772501001, ' +
    '119331, город Москва, пр-кт Вернадского, д. 29, этаж 5 ком./офис 20/б3т, ' +
    'тел. +7 (495) 150-95-70',
  billingHistory: 'История платежей',
  billingActionBuyStandard: (period: string, users: number) =>
    `Покупка на ${period} на ${langRu.userCount(users)}`,
  billingActionProplong: (period: string) => `Продление лицензии на ${period}`,
  billingActionAddUsers: (users: number) =>
    `Добавление ${langRu.userCount(users)} к лицензии`,
  billingStandardEnded: 'Лицензия закончилась',
  billingAddUsersTitle: 'Добавить пользователей к текущей лицензии',
  billingProlongTitle: 'Продление лицензии',
  billingLicenseTill: 'Лицензия до',
  billingTotalUsers: 'Пользователей станет',
  userBlocked: 'заблокирован',
  youBlockedHint:
    'Количества пользователей в лицензии не хватило, ' +
    'поэтому ваш аккаунт не получил доступа к проектам этой компании. ' +
    'Обратитесь к администратору компании.',
  rememberAuth: 'запомнить',
  boardFiltration: 'Фильтрация доски',
  boardRemoveFilter: 'Снять фильтрацию',
  removeAllBoardFilters: (amount: number) => {
    let postfix = ''

    if (amount > 1 && amount < 5) {
      postfix = 'а'
    } else if (amount > 5) {
      postfix = 'ов'
    }

    return `Сбросить ${amount} фильтр${postfix}`
  },
  statistics: 'Статистика',
  statFilterUser: 'Пользователь',
  statFilterDate: 'Дата',
  statFilterProject: 'Проект',
  statFilterActionType: 'Тип действия',
  byUserFilterAssignDate: 'Дата назначения',
  userEventAdd: 'Создание задач, колонок, …',
  userEventDelete: 'Удаление задач, колонок, …',
  userEventRestore: 'Отмена удаления задач, колонок',
  userEventRename: 'Переименование задач, колонок, …',
  userEventMove: 'Перемещение задач, колонок',
  userEventComplete: 'Архивирование задач',
  userEventUncomplete: 'Восстановление задач',
  userEventDone: 'Выполнение задач',
  userEventMessage: 'Сообщения в чате',
  userEventFile: 'Загрузка файла',
  userEventUsers: 'Добавление пользователей',
  userEventsPermissions: 'Изменение прав',

  statActionObjProject: 'проект',
  statActionObjBoard: 'доска',
  statActionObjColumn: 'колонка',
  statActionObjTask: 'задача',
  statActionObjSticker: 'стикер',

  statActionAddProject: 'Добавлен',
  statActionAddOther: 'Добавлена',
  statActionDeleteProject: 'Удалён',
  statActionDeleteOther: 'Удалена',
  statActionRestoreProject: 'Восстановлен',
  statActionRestoreOther: 'Восстановлена',
  statActionRenameProject: 'Переименован',
  statActionRenameOther: 'Переименована',
  statActionMoveProject: 'Перемещён',
  statActionMoveOther: 'Перемещена',

  statActionUncompleteProject: 'Из архива восстановлен проект',
  statActionUncompleteTask: 'Из архива восстановлена задача',
  statActionDone: 'Задача отмечена как выполненная',
  statActionUnDone: 'Задача отмечена как невыполненная',
  statActionMessage: 'Сообщение',
  statActionFile: 'Файл',

  fromTo: (from: string, to: string) => `Из “${from}” в “${to}”`,
  onlineTime: 'Время онлайн',
  restore: 'Восстановить',
  restored: 'восстановлено',
  statsChartTitle: 'Сумма действий пользователей по дням',
  statShowChart: 'Показать график',
  startShowLists: 'Показать список',
  monthNames: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь'
  ],
  weekNamesShort: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
  taskRename: 'Переименовать задачу',
  taskCompleted: 'Задача в архиве',
  logoutYouGile: 'Выход из аккаунта',
  chatTabChat: 'Чат',
  chatTabDescription: 'Описание',
  chatTabSubtasks: 'Подзадачи',
  chatTabConnected: 'Связи задач',
  checklistDefaultName: 'Список',
  checklists: 'Чеклисты',
  subtaskName: 'Название подзадачи',
  assigned: 'Исполнитель',
  systemIsLoading: 'Загрузка данных, подождите...',
  othersTasksPage: 'Задачи пользователей',
  byUserPageTitle: 'Задачи сотрудников',
  byTimeInColumns: 'Время в колонках',
  taskTimesInColumns: 'Время задач в колонках',
  byUserOpenTasksCount: 'Открытых задач',
  byUserNoAssignee: 'Неназначенные задачи',
  byUserTimeHint: 'Время с момента назначения задачи',
  menuArchive: 'Поместить в архив',
  menuUnarchive: 'Восстановить из архива',
  menuCopyLink: 'Скопировать ссылку',
  menuArchiveTasks: 'Архивировать все задачи',
  menuArchiveCompleted: 'Архивировать выполненные',
  sureAchiveAllTasks:
    'Архивировать все задачи, отображаемые сейчас в этой колонке?',
  sureAchiveCompletedTasks:
    'Архивировать все выполненные задачи в этой колонке?',
  menuComplete: 'Отметить выполненной',
  menuUncomplete: 'Выполнена',
  myTasksPage: 'Мои задачи',
  myTasksNew: 'Новые',
  myTasksCurrent: 'Текущие',
  myTasksBacklog: 'На потом',
  myTasksListName: 'Название списка',
  myTasksPrivateListName: 'Название приватного списка',
  myTasksDone: 'Выполненные',
  myTasksIncoming: 'Входящие',
  myTasksImportantTasks: 'Важные задачи',
  myTasksDefaultPrivateList: 'Пример приватного списка',
  myTasksDefaultPrivateTask1: 'Добавить приватный список',
  myTasksDefaultPrivateTask2: 'Создать 4 задачи',
  myTasksDefaultPrivateTask3: 'Отметить выполненные задачи',
  myTasksDefaultPrivateTask4: 'Поменять приватные задачи местами',
  myTasksAddList: 'Добавить список',
  myTasksAddPrivateList: 'Добавить приватный список',
  myTasksRenameList: 'Переименовать список',
  myTasksDeleteList: 'Удалить список',
  myTasksMoveNew: 'В новые',
  myTasksMoveCurrent: 'В текущие',
  myTasksMoveBacklog: 'На потом',
  myTasksMoveAllNew: 'Все в новые',
  myTasksMoveAllCurrent: 'Все в текущие',
  myTasksMoveAllBacklog: 'Все на потом',
  myTasksMoveAllDone: 'Выполнить все',
  myTasksMoveAllUndone: 'Убрать выполнение у всех',
  myTasksMoveAll: 'Переместить все задачи',
  taskLocation: 'Расположение задачи',
  taskStickers: 'Стикеры задачи',
  taskOtherStickers: 'Остальные стикеры',
  noStickers: 'Нет стикеров',
  myTasksAddHint:
    'Чтобы добавить задачу в “Мои задачи”, прикрепите стикер “Исполнитель” к задаче в доске',
  actionsByTime: 'Лента событий',
  unseenMyTaskHint: 'Пользователь ещё не просмотрел(а) задачу',
  rub: 'руб',
  rub2: 'р.',
  showTaskInfo: 'Показать информацию о задаче',
  sortByDeadline: 'Сортировать список по дедлайну',
  markTaskCompleted: 'Отметить задачу выполненной',
  taskTemplateNotCompleted: 'Нельзя выполнить подзадачу в шаблоне',
  markTaskUncompleted(timeStr: string): string {
    return `Задача выполнена ${timeStr}. Нажмите, чтобы отметить невыполненной`
  },
  taskCompletedTimeHint(timeStr: string): string {
    return `Задача выполнена ${timeStr}`
  },
  searchResultsHint1: 'Начните печатать, чтобы увидеть результаты поиска.',
  searchResultsHint2: 'Горячие клавиши:',
  searchResultsHint3: 'начать поиск: Shift-Shift или Command+E,',
  searchResultsHint4: 'навигация по выдаче поиска: стрелки вниз ↓ и вверх ↑,',
  searchResultsHint5: 'переход из выдачи в карточку/в чат: Enter,',
  searchResultsHint6: 'закрыть окно выдачи: Escape.',
  searchIndexing: 'Подготовка данных для поиска. Не все результаты отображены.',

  messageEditHint: 'Редактировать/удалить сообщение',
  messageDeleteHint: 'Удалить сообщение',
  messageEdited: 'Изм.',
  messageEditedHint: (date: string) => `Сообщение было редактировано ${date}`,
  messagePinHint: 'Создать быструю ссылку на сообщение в чате',
  messagePinRemoveHint: 'Удалить быструю ссылку на сообщение в чате',
  messagePinEditHint: 'Быстрая ссылка на сообщение. Нажмите, чтобы изменить',
  messageDeleteConfirm: 'Удалить сообщение?',
  moveProjectsHint:
    'Вы можете изменить порядок проектов, перетаскивая проекты мышью. Порядок проектов изменится только у вас, другие пользователи могут установить свой порядок проектов',
  unreadMessages: 'Непрочитанные сообщения',
  toSearchResults: 'К результатам поиска',
  userListMenuItem: 'Личные чаты',
  chatFilterLabel: 'Настроить фильтрацию списка',
  backNotifyHint: 'Количество непрочитанных сообщений в других чатах',
  deadlineDescr: 'Перенесите стикер мышью на задачу, чтобы установить дедлайн',
  notAdminConfigureWarn:
    'Конфигуратор доступен только администраторам. ' +
    'Откройте компанию, где вы администратор, чтобы конфигурировать её',
  createGroupChat: 'Создать групповой чат',
  editGroupChat: 'Редактировать название группового чата и список участников',
  groupChat: 'Групповой чат',
  groupChatMute:
    'Уведомления по этому чату включены. Нажмите, чтобы отключить уведомления по этому чату',
  groupChatUnmute:
    'Уведомления по этому чату выключены. Нажмите, чтобы включить уведомления по этому чату',
  groupChatSettings: 'Настройки группового чата',
  groupChatTitlePlaceholder: 'Введите название чата',
  groupChatParticipants: 'Список участников',
  groupChatNew: 'Новый групповой чат',
  groupChatNoUsersOnCreate:
    'Вы не выбрали пользователей для группового чата, выберите хотя бы одного пользователя, чтобы создать групповой чат',
  groupChatNoUsersOnEdit: 'Удалить групповой чат?',
  groupChatNoUsersOnEditHint:
    'Вы удалили всех пользователей из группового чата, он не будет доступен никому и удалён',
  subscribedToTask: 'Участники чата',
  chatSubscribe: 'Подписаться',
  chatUnsubscribe: 'Отписаться',
  chatSubscribeAll: 'Отметить всех в списке',
  chatUnsubscribeAll: 'никого',
  chatSubscribeReverse: 'инвертировать',
  chatSubscribeSearch: 'Поиск по списку',
  feedbackChatDescription:
    'Это чат со службой поддержки YouGile. Он виден только вам и сотрудникам YouGile',
  reportsTitle: 'Отчёты',
  fieldIdTask: 'ID задачи',
  fieldTitle: 'Название задачи',
  fieldDescription: 'Описание задачи',
  fieldChecklist: 'Чеклисты',
  fieldCreatedAt: 'Создана',
  fieldCreatedBy: 'Автор',
  fieldAssignedTo: 'Исполнитель',
  fieldResponsible: 'Ответственный',
  fieldAssignedAt: 'Дата назначения',
  fieldCompletedAt: 'Дата выполнения',
  fieldDeadline: 'Дедлайн',
  fieldProject: 'Проект',
  fieldBoard: 'Доска',
  fieldColumn: 'Колонка',
  fieldLastMove: 'Перемещена',
  fieldlastMessage: 'Дата последнего сообщения',
  fieldMessagesCount: 'Кол-во сообщений',
  statsReport: 'Отчёт',
  statsAddReport: 'Добавить новый отчёт',
  statsAddColumnReport: 'Добавить новую сводку',
  statsEditReport: 'Настроить отчёт',
  statsEditColumnReport: 'Настроить сводку',
  statsDownloadXlsx: 'Скачать отчёт',
  statsReportName: 'Название отчёта',
  statsColumnReportName: 'Название сводки',
  statsDeleteReport: 'Удалить отчёт',
  statsDeleteColumnReport: 'Удалить сводку',
  statsSort: 'Сортировка задач',
  statsFilter: 'Фильтрация задач',
  statsFilterAny: 'Любое значение',
  statsFilterAnyProject: 'Любой проект',
  statsFilterAnyBoard: 'Все доски',
  statsFilterWithoutBoard: 'Без доски',
  statsFilterAnyColumn: 'Все колонки',
  statsFilterCreatedBy: 'Автор задачи',
  statsFilterCreatedAt: 'Дата создания',
  statsFilterAssignedTo: 'Исполнитель',
  statsFilterAssignedBy: 'Поручивший задачу',
  statsFilterResponsible: 'Ответственный',
  statsFilterMoveDate: 'Дата последнего перемещения',
  statsFilterLastMessage: 'Дата последнего сообщения',
  statsFilterDeadline: 'Дедлайн',
  statsFilterStickers: 'Стикеры',
  statsFilterDate1d: 'Сегодня',
  statsFilter7d: 'Последние 7 дней',
  statsFilter30d: 'Последние 30 дней',
  statsFilterNext7d: 'Следующие 7 дней',
  statsFilterNext30d: 'Следующие 30 дней',
  statsFilterCurrentWeek: 'Текущая неделя',
  statsFilterCurrentMonth: 'Текущий месяц',
  statsFilterPrevWeek: 'Прошлая неделя',
  statsFilterPrevMonth: 'Прошлый месяц',
  statsFilterNextWeek: 'Следующая неделя',
  statsFilterNextMonth: 'Следующий месяц',
  statsNotSet: 'Не назначен',
  statsUserNotSet: 'Пользователь не назначен',
  statsNotPinned: 'Не прикреплён',
  statsTasksFound: 'Всего задач',
  statsPage: 'Страница',
  statsPrev: 'Предыдущая',
  statsNext: 'Следующая',
  totalValueByColumn: 'Суммарное значение по колонке',
  sumOfValues: 'Сумма значений',
  statFilterCompleteness: 'Статус выполнения',
  statsCompleteAny: 'Любой',
  statsCompleteCompleted: 'Выполнена',
  statsCompleteNotCompleted: 'Не выполнена',
  statCompletedAt: 'Дата выполнения',
  statFilterArchiveness: 'Статус архивации',
  statArchivenessNo: 'Не в архиве',
  statArchivenessYes: 'В архиве',
  statArchivenessAny: 'Любой',
  statSticker: 'Стикер',
  statAddSticker: 'Добавить стикер',
  statChooseSticker: 'Выберите стикер',
  statChooseState: 'Состояние стикера',
  statStateIncludeHint:
    'Включены задачи с этим состоянием. Нажмите, чтобы исключить задачи с этим состоянием стикера',
  statStateExcludeHint:
    'Задачи с этим состоянием исключены. Нажмите, чтобы включить задачи с этим состоянием стикера',
  statsTimetrackingSet: 'Установлен',
  statsTimetrackingNotSet: 'Не установлен',
  statsTimetrackingExceedsPlan: 'Превышает план',
  statsTimetrackingNotExceedsPlan: 'Не превышает план',
  statsDeleteReportConfirm: 'Удалить отчёт?',
  specifyValue: 'Указать значение',
  specifyStickerValueForThatSticker: 'Укажите значение стикера для этой задачи',
  boardCreateDashboard: 'Создать сводку',
  dashboard: 'Сводка',
  downloadDashboardXlsx: 'Скачать сводку в виде *.xlsx-файла',
  dashboardSettings: 'Настройки сводки',
  boardDeleteReportConfirm: 'Удалить сводку?',
  result: 'Результат',
  reportNoDragTask:
    'Задачи в сводках не таскаются. Перенесите эту задачу из обычной или зеркальной колонки, в которой она присутствует.',
  asc: 'По возрастанию',
  desc: 'По убыванию',
  statsAddFilter: 'Добавить фильтр',
  statsChooseFilter: 'Выберите фильтр',
  statsAddSort: 'Добавить сортировку',
  statsChooseSort: 'Выберите сортировку',
  statsIncluded: 'Включено',
  statsExcluded: 'Исключено',
  statsAddLocation: 'Добавить расположение',
  noProjectsHint:
    'Вы не добавлены ни в один проект компании, обратитесь к администратору компании, чтобы получить доступ к проектам',
  datePickerFrom: 'С',
  datePickerTill: 'до',
  datePickerBlockedRangeStart:
    'Невозможно изменить дату начала этой задачи, поскольку она зависит от другой задачи',
  addTaskStickerErrorMessage:
    'Необходимо проставить значения выделенных стикеров',
  addTaskEmptyTextErrorMessage: 'Необходимо указать название задачи',
  changesHistory: 'История изменений',
  changesHistoryHint: 'Вы можете копировать отсюда текст',
  changesHistorySubmit: 'Восстановить эту версию',
  historyIsEmpty: 'История версий пуста',
  historyIsEmptyHint:
    'Здесь будут отображаться версии после изменения описания',
  descriptionIsEmpty: 'Пока здесь пусто',
  descriptionIsEmptyHint:
    'Нажмите “Редактировать описание”, чтобы добавить текст.',
  userIsNotFound: 'Пользователь не найден',
  setTaskImage: 'Сделать обложкой',
  setChatImage: 'Сделать обложкой чата',
  removeTaskImage: 'Убрать обложку',
  removeCurrentTaskImage: 'Убрать текущую обложку',
  uploadTaskImage: 'Загрузить обложку...',
  datePlaceholder: 'ДД.ММ.ГГГГ',
  emptySearchResults: 'Ничего не найдено',

  alreadyConnected: 'Ссылка на задачу уже создана',

  errorUserAccountIsReadonly:
    'Аккаунт пользователя предназначен только для чтения',
  errorUserIdIsNotValid: 'Некорректный user id',
  errorEmailIsNotValid: 'Некорректный e-mail',
  errorUserNotFound: 'Пользователь не найден',
  errorCompanyNotFound: 'Компания не найдена',
  errorIncorrectPassword: 'Неправильный пароль',
  errorIncorrectToken: 'Неправильный токен',
  errorExpiredToken: 'Время жизни токена истекло',
  errorUnknown: 'Неизвестная ошибка',
  errorEmailAddressAlreadyInUse: 'E-mail уже используется',
  errorForbiddenByCompanyPermissions: (companyName: string): string =>
    `Это действие запрещено правилами компании "${companyName}"`,
  errorNotSaveData: 'Внимание! Несохранённые данные!',
  googleCalendarIntegration: 'Интеграция задач в Google Календарь',
  chooseGoogleAccount: 'Выберите Google-аккаунт',
  chooseCalendar: 'Выберите календарь',
  chooseBoardProject: 'Выберите доски/проекты',
  voiceMessageTitle: '🎤 Голосовое сообщение',
  undefined: 'Не определено',

  showSystemMessages: 'Показывать системные сообщения в чате после просмотра',
  hideSystemMessages: 'Скрывать системные сообщения в чате после просмотра',
  showSystemMessagesShort: 'Показывать системные сообщения в чате',
  hideSystemMessagesShort: 'Скрывать системные сообщения в чате',

  nothingInClipboard: 'В буфере обмена ничего нет',
  noLinkInClipboard: 'В буфере обмена нет ссылки на задачу: ',
  noTaskByHashInClipboard: 'По данной ссылке задача не найдена: ',
  noPermissionToRenameInTargetColumnMoveCancelled:
    'У вас нет прав на переименование этой задачи в целевой колонке. Перемещение отменено.',
  noPermissionToEditStopwatchOnComplete:
    'У вас нет прав для старта или остановки секундомера на задаче.',
  errorOnlyDigitsAllowed: 'Разрешены только цифры',
  errorInvalidEmail: 'Некорректный email',
  errorInvalidURL: 'Некорректный адрес сайта',
  empty: 'Пусто'
}
